<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12" class="pt-0" TRANSACTIONS>
            <v-row>
              <v-col cols="12" PANNELS>
                <v-card flat :loading="loading">
                  <v-card-text class="text-center pa-12" v-if="false">
                    <v-progress-circular size="300" indeterminate color="primary"></v-progress-circular>
                  </v-card-text>
                  <v-card-text class="py-0 pt-0">
                    <v-row>
                      <v-col cols="12" v-if="product">
                        <v-row class="">
                          <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pt-0`" BREADCRAMP>
                            <span class="primary--text" style="cursor:pointer;" @click="goTo('/home')">{{ i18n['home'] }}</span>
                            <span><v-icon>chevron_left</v-icon></span>
                            <span class="primary--text" style="cursor:pointer;" @click="goTo('/dashboard')">{{ i18n['products'] }}</span>
                            <span><v-icon>chevron_left</v-icon></span>
                            <span class="primary--text" style="cursor:pointer;" @click="goTo(`/category/${cat}`)">{{cats[cat]}}</span>
                            <span><v-icon>chevron_left</v-icon></span>
                            <span>{{product.sku}} - {{product.name_ar}}</span>
                          </v-col>
                          <v-col cols="12" md="4" class="text-center" IMAGE>
                              <v-row IMAGE DIV>
                                <v-col cols="12" class="pa-0">
                                  <v-card flat outlined>
                                    <v-row IMAGE DIV>
                                      <v-col cols="12" class="pa-4 py-0 pt-2 ma-0">
                                        <div style="text-align:center;cursor:pointer;height:380px;">
                                          <img
                                            v-if="!lazyLoad &&  product.image && product.image.url"
                                            :src="product.active_image.url"
                                            style="max-width:100%;height:380px;"
                                          >
                                          <AppImg
                                            v-if="lazyLoad &&  product.image && product.image.url"
                                            :src="`/placeholder.jpg`"
                                            :lazy-src="product.active_image.url"
                                            :lazy-srcset="product.active_image.url"
                                            @click="()=>{
                                                if(!cart.map(x=>x.sku).includes(product.sku)) {
                                                  addToCart(product)
                                                }
                                              }"
                                          />
                                          <ImagesSlider
                                            v-if="product.images.length > 1 && false"
                                            :product="product"
                                          />
                                        </div>
                                      </v-col>
                                      <v-col cols="12" class="px-4 py-0 ma-0">
                                        <v-row>
                                          <v-col cols="3" v-for="(image, m) in product.images" :key="'image'+m">
                                            <img width="100%" :src="image.url" alt="" style="cursor:pointer;" @click="()=>{
                                              product.active_image = image
                                            }">
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                </v-col>
                                <v-col cols="12" class="pa-0 py-1">
                                  <v-btn color="success" block large outlined :class="`${arabic?'arFont':'enFont'}`" @click="downLoadAll(product.id)">
                                    {{ i18n['download_all_photos_to_your_pc'] }}
                                    <v-icon right>download</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                          </v-col>
                          <v-col cols="12" md="8" PRDUCT-DETAILS>
                            <v-row class="pa-2">
                              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`" NAME-CAT>
                                <v-row :class="`${arabic?'arFont':'enFont'} pb-2`">
                                  <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pb-2`">
                                    {{ i18n['product_name'] }}
                                  </v-col>
                                </v-row>
                                <div 
                                  :class="`${arabic?'arFont':'enFont'} secondary--text pt-3`" 
                                  style="font-size:24px;">
                                  {{ product.name_ar.trim() }}
                                </div>
                                <div 
                                  :class="`${arabic?'arFont':'enFont'} pt-2 pb-3`" 
                                  style="font-size:11px;">
                                  {{ product.name_en.trim() }}
                                  <v-btn 
                                    v-clipboard:copy="product.name_en"
                                    v-clipboard:success="clipboardSuccessHandler"
                                    v-clipboard:error="clipboardErrorHandler"
                                    color="success" 
                                    x-small 
                                    icon>
                                    <v-icon size="10">content_copy</v-icon>
                                  </v-btn>
                                </div>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`">
                                  <v-chip label x-small :class="`${arabic?'arFont':'enFont'}`">
                                    {{ i18n['product_code'] }}
                                  </v-chip>
                                  <span class="success--text px-2">{{product.sku}}</span>
                                </div>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="6" md="6" :class="`${arabic?'arFont':'enFont'}`" PRICE-SECTION>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`">
                                  {{ i18n["product_price"] }}
                                </div>
                                <div class="headline warning--text">
                                  {{ product.price }}  
                                  <span 
                                    :class="`${arabic?'arFont':'enFont'}`"
                                    :style="`font-size: 14px;`">
                                    {{currency_symbol}}
                                  </span>
                                </div>
                              </v-col>
                              <v-col cols="6" md="6" :class="`${arabic?'arFont':'enFont'}`" PROFIT-SECTION>
                                <div :class="`${arabic?'arFont':'enFont'} pb-2`">
                                  {{ i18n["net_profit"] }}
                                </div>
                                <div class="headline success--text">
                                  {{ product.user_profit }}  
                                  <span 
                                    :class="`${arabic?'arFont':'enFont'}`"
                                    :style="`font-size: 14px;`">
                                    {{currency_symbol}}
                                  </span>
                                </div>
                              </v-col>
                              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`" QTY-AVAILABLE>
                                <div :class="`${arabic?'arFont':'enFont'}`">
                                  <v-chip label small color="success" dark :class="`${arabic?'arFont':'enFont'}`">
                                    {{ i18n['product_is_available'] }}
                                  </v-chip>
                                  {{ i18n['number_of_pieces_availble']}} {{ product.count }}
                                </div>
                              </v-col>
                              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`" QTY-FIELD v-if="product.flash_item && product.delayed_flash">
                                <div style="font-size:18px;font-weight:700;" class="mb-2 success--text">
                                  {{ i18n['offer_will_start_after'] }}
                                </div>
                                <div>
                                  <countdown :time="product.start_remaining">
                                    <template slot-scope="props">
                                      <v-progress-circular size="80" :value="props.days" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.days}}<br/>
                                        {{ i18n['day'] }}
                                        </span>
                                      </v-progress-circular>
                                      <v-progress-circular size="80" :value="props.hours" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.hours}}<br/>
                                        {{ i18n['hour'] }}
                                        </span>
                                      </v-progress-circular>
                                      <v-progress-circular size="80" :value="props.minutes" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.minutes}}<br/>
                                        {{ i18n['minute'] }}
                                        </span>
                                      </v-progress-circular>
                                      <v-progress-circular size="80" :value="props.seconds" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.seconds}}<br/>
                                        {{ i18n['second'] }}
                                        </span>
                                      </v-progress-circular>
                                    </template>
                                  </countdown>
                                </div>
                                <div style="font-size:18px;font-weight:700;" class="mt-2 success--text">
                                  {{ i18n['the_price_of_this_product_will_drop_to'] }} {{ product.flash_price.toFixed(1) }} <span 
                                      :class="`${arabic?'arFont':'enFont'}`"
                                      :style="`font-size: 11px;`">
                                      {{currency_symbol}}
                                    </span>
                                </div>
                              </v-col>
                              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`" QTY-FIELD v-if="product.flash_item && !product.delayed_flash">
                                <div style="font-size:18px;font-weight:700;" class="mb-2 error--text">
                                  {{ i18n['left_for_this_offer'] }}
                                </div>
                                <div>
                                  <countdown :time="product.end_remaining">
                                    <template slot-scope="props">
                                      <v-progress-circular size="80" :value="props.days" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.days}}<br/>
                                        {{i18n['day']}}
                                        </span>
                                      </v-progress-circular>
                                      <v-progress-circular size="80" :value="props.hours" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.hours}}<br/>
                                        {{i18n['hour'] }}
                                        </span>
                                      </v-progress-circular>
                                      <v-progress-circular size="80" :value="props.minutes" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.minutes}}<br/>
                                        {{i18n['minute'] }}
                                        </span>
                                      </v-progress-circular>
                                      <v-progress-circular size="80" :value="props.seconds" :color="`${product.delayed_flash ? 'success' : 'error'}`">
                                      <span style="font-size:16px;line-height:18px;" class="text-center">
                                        {{props.seconds}}<br/>
                                        {{i18n['second'] }}
                                        </span>
                                      </v-progress-circular>
                                    </template>
                                  </countdown>
                                </div>
                                <div style="font-size:18px;font-weight:700;" class="mt-2 error--text">
                                  {{ i18n['this_offer_will_end_then_price_will_go_back_to'] }} {{ product.before_flash_price.toFixed(1) }} <span 
                                    :class="`${arabic?'arFont':'enFont'}`"
                                    :style="`font-size: 11px;`">
                                    {{currency_symbol}}
                                  </span>
                                  {{ i18n['after'] }} {{product.remaining_hours.toFixed(1)}} {{i18n['hour']}}
                                </div>
                              </v-col>
                              <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`" QTY-FIELD v-if="!product.delayed_flash">
                                <v-text-field
                                  :label="i18n['quantity']"
                                  outlined
                                  dense
                                  hide-details
                                  :loading="loading"
                                  v-model="quantity"
                                  :class="`${arabic?'arFont':'enFont'}`"
                                  @click:append-outer="increaseQuantity(product)"
                                  @click:prepend="decreaseQuantity(product)"
                                >
                                  <template v-slot:prepend>
                                    <v-tooltip
                                      top
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-btn small :loading="loading" color="error" icon outlined v-on="on" @click="decreaseQuantity(product)">
                                          <v-icon>
                                            arrow_drop_down
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span :class="`${arabic?'arFont':'enFont'}`">
                                        {{ i18n['reduce_quantity'] }}
                                      </span>
                                    </v-tooltip>
                                  </template>
                                  <template v-slot:append-outer>
                                    <v-tooltip
                                      top
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-btn small :loading="loading" color="success" icon outlined v-on="on" @click="increaseQuantity(product)">
                                          <v-icon>
                                            arrow_drop_up
                                          </v-icon>
                                        </v-btn>
                                      </template>
                                      <span :class="`${arabic?'arFont':'enFont'}`">
                                        {{ i18n['increase_quantity'] }}
                                      </span>
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </v-col>
                              <v-col cols="12" md="6" class="px-1" BTNS-ADD-AND-ORDER v-if="!product.delayed_flash">
                                <v-btn color="error" block 
                                :class="`${arabic?'arFont':'enFont'} faddtocart mb-1`"
                                @click="removeFromCart(product)"
                                v-if="cart.map(x=>x.sku).includes(product.sku)"
                                :disabled="!cart.map(x=>x.sku).includes(product.sku)"
                                :text="!cart.map(x=>x.sku).includes(product.sku)"
                                :loading="loading"
                                >
                                  <v-icon 
                                    :right="language == 'en'"
                                    :left="language == 'ar'"
                                  >shopping_cart</v-icon>
                                  <span>
                                    {{ i18n['remove_from_cart'] }}
                                  </span> 
                                </v-btn>
                                <v-btn color="error" block 
                                :class="`${arabic?'arFont':'enFont'} faddtocart mb-1`"
                                @click="addToCart(product)"
                                :disabled="cart.map(x=>x.sku).includes(product.sku)"
                                v-if="!cart.map(x=>x.sku).includes(product.sku)"
                                :text="!cart.map(x=>x.sku).includes(product.sku)"
                                :loading="loading"
                                >
                                  <v-icon 
                                    :right="language == 'en'"
                                    :left="language == 'ar'"
                                  >shopping_cart</v-icon>
                                  <span v-if="!cart.map(x=>x.sku).includes(product.sku)">
                                    {{ i18n.add_to_cart }}
                                  </span> 
                                  <span v-if="cart.map(x=>x.sku).includes(product.sku)">
                                    {{ i18n.added_to_cart }}
                                  </span> 
                                </v-btn>
                                
                              </v-col>
                              <v-col cols="12" md="6" class="px-1" BTN-CAT-FAV>
                                <v-btn color="primary" block 
                                :class="`${arabic?'arFont':'enFont'}`"
                                @click="addToFav(product.id)"
                                :loading="loading"
                                v-if="!product.fav"
                                text
                                >
                                  <span>
                                    {{ i18n['add_to_your_products'] }}
                                  </span> 
                                  <v-icon right>favorite_border</v-icon>
                                </v-btn>
                                <v-btn color="error" block 
                                :class="`${arabic?'arFont':'enFont'}`"
                                @click="rmvFav(product.id)"
                                :loading="loading"
                                v-if="product.fav"
                                text
                                >
                                  <span>
                                    {{ i18n['remove_from_your_products'] }}
                                  </span> 
                                  <v-icon right>favorite</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col cols="12" md="6" class="px-1" BTN-OPEN-CART v-if="!product.delayed_flash">
                                <v-btn block color="secondary" :disabled="!cart.length" @click="()=>{
                                    openCart();
                                  }" :class="`${arabic?'arFont':'enFont'}`">
                                  {{ i18n['finish_order'] }}
                                </v-btn>
                              </v-col>
                              <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:20px;" DIVIDER>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" AVAILABLES>
                                <v-row class="align-start" >
                                  <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} px-2`" style="font-weight:bold;">
                                    {{ i18n['product_is_available_in_the_following_countries'] }}
                                  </v-col>
                                  <v-col cols="4" md="2" :class="`${arabic?'arFont':'enFont'} px-2`" v-for="(r, c) in remaining" :key="'count'+c">
                                    <div class="text-right" v-if="r && r.alpha2Code" style="cursor:pointer;" @click="goTo(`/product/${r.alpha2Code}/${product.hash}`)">
                                      <img width="35px" style="filter:drop-shadow(2px 2px 4px rgb(0 0 0 / 38%));" :src="`/flags/${r.alpha2Code.toLowerCase()}.png`" alt="">
                                      <div>
                                        {{countries_[language][r.alpha2Code.toLowerCase()]}}
                                      </div>
                                      <div class="py-1">
                                        {{ i18n['quantity'] }}: {{r.count}}
                                      </div>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" style="font-size:20px;" DIVIDER>
                                <v-divider></v-divider>
                              </v-col>
                              <v-col cols="12" :class="`${arabic?'arFont':'enFont'} `" VIDEO-AND-DESCRIPTION>
                                <v-tabs
                                  v-model="tab"
                                >
                                  <v-tabs-slider></v-tabs-slider>
                                  <v-tab href="#tab-1" :class="`${arabic?'arFont':'enFont'} `">
                                    {{ i18n['product_description'] }}
                                  </v-tab>
                                  <v-tab href="#tab-2" :class="`${arabic?'arFont':'enFont'} `">
                                    {{ i18n['product_video'] }}
                                  </v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="tab">
                                  <v-tab-item
                                    :value="'tab-1'"
                                  >
                                    <v-card flat>
                                      <v-card-text v-html="product.description_ar" ></v-card-text>
                                    </v-card>
                                  </v-tab-item>
                                  <v-tab-item
                                    :value="'tab-2'"
                                  >
                                    <v-card flat>
                                      <v-card-text v-html="getSource(product)" ></v-card-text>
                                    </v-card>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" md="12" RELATED>
                            <div :class="`${arabic?'arFont':'enFont'} pb-2`" style="font-size:18px;font-weight:bold;">
                              {{ i18n['similar_products'] }}
                            </div>
                            <productSlider @reload="getProduct" :products="products" :loading="loading" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                    <v-btn 
                      :class="`${arabic?'arFont':'enFont'}`" 
                      large 
                      :loading="loading"
                      color="secondary" 
                      @click="goTo('/dashboard')" 
                      block 
                      text>
                      {{ i18n['back_to_products'] }}
                    </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppImg from '@/components/imgPlaceholder';
import productSlider from '@/components/productSlider';
import ImagesSlider from '@/components/ImagesSlider';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components:{ AppImg, ImagesSlider, productSlider },
  data() {
    return {
      loading:true,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      product:null,
      lazyLoad:false,
      tab:null,
      products:[],
      countries:[],
      
      cats:{
        best_sellers:`المنتجات الاكثر مبيعا`,
        new_products:`منتجات جديدة`,
        all:`جميع المنتجات`,
      }
    }
  },
  methods: {
    async downLoadAll(id) {
      this.loading = true
      window.open(`https://product.yervip.com/api/v1/download/${id}`, '_blank').focus();
      this.loading = false
      
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async addToFav(id){
      let a = await this.$store.dispatch('getResource', {resource:`/bayaa-fav/${id}`})
      this.$emit('snackbarNotification', this.i18n['added_to_your_products'], 'success')
      this.getProduct()
    },
    async rmvFav(id){
      let a = await this.$store.dispatch('deleteResource', {resource:`/favs/${id}`})
      this.$emit('snackbarNotification', this.i18n['removed_from_your_products'], 'success')
      this.getProduct()
    },
    getSource(p){
      if(p.youtube) {
        return `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${p.youtube.replace('https://www.youtube.com/watch?v=', '').replace('youtube.com/watch?v=', '')}" title="${p.name_ar}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      } else {
        return ''
      }
    },
    increaseQuantity(p){
      if(!this.cart.map(x=>x.sku).includes(p.sku)) {
        this.addToCart(p)
      } else {
        this.$store.dispatch('increaseQuantity', p)
      }
    },
    decreaseQuantity(p){
      if(this.cart.map(x=>x.sku).includes(p.sku) && this.quantity == 1 && this.quantity > 0) {
        this.removeFromCart(p)
      } else if (this.cart.map(x=>x.sku).includes(p.sku)) {
        this.$store.dispatch('decreaseQuantity', p)
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    removeFromCart(p) {
      this.$store.dispatch('removeFromCart', p)
    },
    openCart(){
      this.$store.dispatch('openCart')
    },
    addToCart(product) {
      this.$store.dispatch('addToCart', product)
      if(typeof ttq !== 'undefined') {
        ttq.track('AddToCart')
      }
      if(typeof snaptr !== 'undefined') {
          snaptr('track', 'ADD_CART');
      }
      if(typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart');
      }
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    favPricing(products) {
      let state = this.$store.state
      let favs = this.favs.map(x=>x.product_id)
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        products[i].active_image = products[i].image

        if(favs.includes(product.id)){
          product.fav = true
        } else {
          product.fav = false
        }
        // console.log(product)
        let f = product.vprices.filter(x=> x.country && ( x.country.name == 'ALL' || x.country.id ==  state.country.id))
        if(f.length) {
          product.price_name = f[0].name
          product.base_price = parseFloat((parseFloat(f[0].value)).toFixed(2))
          product.price = parseFloat((parseFloat(f[0].value) * state.currency_factor).toFixed(1))
          product.base_profit = parseFloat((parseFloat(f[0].value) * 0.2).toFixed(2))
          product.profit = parseFloat((parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(1))
          product.user_base_profit = parseFloat((parseFloat(f[0].value) * 0.2).toFixed(2))
          product.user_profit = parseFloat((parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(1))
          product.currency_factor = state.currency_factor
          if(f[0] && f[0].flash_item) {
            product.before_flash_price = parseFloat((parseFloat(f[0].before_flash_price) * state.currency_factor).toFixed(8))
            product.flash_item = true
            product.flash_hours = f[0].flash_hours
            product.flash_price = parseFloat((parseFloat(f[0].flash_price) * state.currency_factor).toFixed(8))
            product.flash_start = f[0].flash_start
            product.flash_end = f[0].flash_end
            product.flash_start_hours = f[0].flash_start_hours
            product.delayed_flash = f[0].delayed_flash
            product.start_remaining = f[0].start_remaining
            product.end_remaining = f[0].end_remaining
            product.remaining_hours = f[0].remaining_hours

          }
          // if(state.tax) {
          //   product.price = parseFloat((parseFloat(product.price) + product.price * state.tax).toFixed(1))
          // }
        }
        let c = product.remaining.filter(x=> x.country_id ==  state.country.id )
        if(c.length) {
          product.count = c[0].count
        }
      }
      return products
    },
    async getProduct(){
      this.loading = true
      this.$store.dispatch('getFavs')
      let h = this.$route.params.hash
      let data = await axios.get(`https://product.yervip.com/api/v1/bayaa-product/${this.$route.params.cc}/${h}`).then(x=>x.data)
      localStorage.country = JSON.stringify(data.countries.filter(x=>x.alpha2Code == this.$route.params.cc)[0])
      this.$store.state.country = data.countries.filter(x=>x.alpha2Code == this.$route.params.cc)[0]
      this.countries = data.countries
      this.$store.state.countries = data.countries
        // console.log(this.cc)
        // console.log(data.countries)
      await this.$store.dispatch('manualCountry', data.countries.filter(x=>x.alpha2Code == this.$route.params.cc)[0])
      this.product = this.favPricing([data.product])[0]
      this.products = this.favPricing(data.related)
      this.setResourceName(this.product.name_ar)
      this.loading = false
      // console.log('pr data', data)
    },
    setResourceName(n){
      this.resourceSettings.resourceName = n
    }
  },
  computed:{
    countries_() {
      return this.$store.state.countries_
    },
    cat() {
      return this.$store.state.category
    },
    remaining(){
      if(this.product.remaining && this.countries.length) {
        return this.product.remaining.map(x=>{
          let country = this.countries.filter(y=>y.id == x.country_id)[0]
          return {
            ...x,
            ...country
          }
        }).filter(x=>x.count>0 && x.alpha2Code)
      } else {
        return []
      }
    },
    favs(){
      return this.$store.state.favs
    },
    cc(){
      return this.$store.state.country ? this.$store.state.country.alpha2Code: this.$route.params.cc
    },
    quantity(){
      if(this.$store.state.cart.length &&  this.$store.state.cart.map(x=>x.sku).includes(this.product.sku) && this.product && this.product.sku) {
        return this.$store.state.cart[this.$store.state.cart.findIndex(x=> x.sku == this.product.sku)].order_quantity
      } else {
        return 0
      }
    },
    cart(){
      return this.$store.state.cart
    },
    currency_symbol(){
      return this.$store.state.currency_symbol
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  watch:{
    $route(){
      this.getProduct()
    }
  },
  async created(){
    this.getProduct()
  },
}
</script>

<style>

</style>